import React from 'react';
import starai_logo from '../assets/starai_logo.png';
import ConpanyName_Image from '../assets/company_name.png';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-gray-50 via-white to-brand-primary/10 border-t border-gray-200/50 relative overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-gradient-to-br from-brand-primary/10 to-brand-secondary/10 rounded-full blur-3xl"></div>
        <div className="absolute top-0 left-0 w-80 h-80 bg-gradient-to-br from-brand-secondary/10 to-brand-primary/10 rounded-full blur-3xl"></div>
      </div>
      
      <div className="relative z-10">
        {/* Main Footer Content */}
        <div className="max-w-7xl mx-auto px-4 sm:px-8 py-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">
            {/* Company Info */}
            <div className="lg:col-span-2">
              <div className="flex items-center space-x-3 mb-6">
                {/* <div className="relative">
                  
                  <div className="absolute inset-0 bg-gradient-to-r from-brand-primary to-brand-secondary rounded-full opacity-0 hover:opacity-20 transition-opacity duration-300"></div>
                </div> */}
                <div>
                <img src={ConpanyName_Image} alt="StarAI Logo" className="h-12" />
                  <p className="text-brand-primary font-medium text-sm">Công ty Cổ phần Tư vấn Ngôi Sao AI</p>
                </div>
              </div>
              <p className="text-gray-600 mb-8 text-lg leading-relaxed max-w-lg">
                Tiên phong trong lĩnh vực tư vấn và đào tạo ứng dụng Trí tuệ nhân tạo trong doanh nghiệp. 
                Chúng tôi cam kết mang đến những giải pháp AI hiện đại nhất cho sự phát triển bền vững của doanh nghiệp Việt Nam.
              </p>
              
              {/* Social Media */}
              <div className="flex space-x-4 mb-8">
                <a href="#" className="w-12 h-12 bg-gradient-to-r from-brand-primary to-brand-secondary text-white rounded-xl flex items-center justify-center hover:from-brand-secondary hover:to-brand-dark transition-all duration-300 transform hover:scale-110 shadow-lg hover:shadow-xl">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"/>
                  </svg>
                </a>
                <a href="#" className="w-12 h-12 bg-gradient-to-r from-brand-secondary to-brand-dark text-white rounded-xl flex items-center justify-center hover:from-brand-dark hover:to-brand-dark transition-all duration-300 transform hover:scale-110 shadow-lg hover:shadow-xl">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                </a>
                <a href="#" className="w-12 h-12 bg-gradient-to-r from-brand-primary to-brand-secondary text-white rounded-xl flex items-center justify-center hover:from-brand-secondary hover:to-brand-dark transition-all duration-300 transform hover:scale-110 shadow-lg hover:shadow-xl">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.174-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.402.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.357-.629-2.746-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24.009 12.017 24.009c6.624 0 11.99-5.367 11.99-11.988C24.007 5.367 18.641.001 12.017.001z"/>
                  </svg>
                </a>
                <a href="#" className="w-12 h-12 bg-gradient-to-r from-brand-secondary to-brand-dark text-white rounded-xl flex items-center justify-center hover:from-brand-dark hover:to-brand-dark transition-all duration-300 transform hover:scale-110 shadow-lg hover:shadow-xl">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                  </svg>
                </a>
              </div>
              
              {/* Newsletter */}
              <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 border border-gray-200/50">
                <h4 className="font-bold text-gray-800 text-lg mb-3">Đăng ký nhận tin</h4>
                <p className="text-gray-600 text-sm mb-4">Nhận thông tin mới nhất về AI và công nghệ</p>
                <div className="flex space-x-2">
                  <input 
                    type="email" 
                    placeholder="Email của bạn" 
                    className="flex-1 px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-brand-primary focus:border-transparent"
                  />
                  <button className="px-6 py-3 bg-gradient-to-r from-brand-primary to-brand-secondary text-white font-semibold rounded-xl hover:from-brand-secondary hover:to-brand-dark transition-all duration-300 transform hover:scale-105">
                    Đăng ký
                  </button>
                </div>
              </div>
            </div>
            
            {/* Quick Links */}
            <div>
              <h4 className="font-bold text-gray-800 text-xl mb-6">Liên kết nhanh</h4>
              <ul className="space-y-4">
                <li><a href="#home" className="text-gray-600 hover:text-brand-primary transition-colors flex items-center group">
                  <span className="w-2 h-2 bg-brand-primary rounded-full mr-3 group-hover:scale-125 transition-transform"></span>
                  Trang chủ
                </a></li>
                <li><a href="#solutions" className="text-gray-600 hover:text-brand-primary transition-colors flex items-center group">
                  <span className="w-2 h-2 bg-brand-primary rounded-full mr-3 group-hover:scale-125 transition-transform"></span>
                  Giải pháp AI
                </a></li>
                <li><a href="#intro" className="text-gray-600 hover:text-brand-primary transition-colors flex items-center group">
                  <span className="w-2 h-2 bg-brand-primary rounded-full mr-3 group-hover:scale-125 transition-transform"></span>
                  Tư vấn
                </a></li>
                <li><a href="#training" className="text-gray-600 hover:text-brand-primary transition-colors flex items-center group">
                  <span className="w-2 h-2 bg-brand-primary rounded-full mr-3 group-hover:scale-125 transition-transform"></span>
                  Đào tạo
                </a></li>
                <li><a href="#about" className="text-gray-600 hover:text-brand-primary transition-colors flex items-center group">
                  <span className="w-2 h-2 bg-brand-primary rounded-full mr-3 group-hover:scale-125 transition-transform"></span>
                  Về chúng tôi
                </a></li>
                <li><a href="#contact" className="text-gray-600 hover:text-brand-primary transition-colors flex items-center group">
                  <span className="w-2 h-2 bg-brand-primary rounded-full mr-3 group-hover:scale-125 transition-transform"></span>
                  Liên hệ
                </a></li>
              </ul>
            </div>
            
            {/* Services */}
            <div>
              <h4 className="font-bold text-gray-800 text-xl mb-6">Dịch vụ</h4>
              <ul className="space-y-4">
                <li><a href="#" className="text-gray-600 hover:text-brand-primary transition-colors flex items-center group">
                  <span className="w-2 h-2 bg-brand-secondary rounded-full mr-3 group-hover:scale-125 transition-transform"></span>
                  Tư vấn chiến lược AI
                </a></li>
                <li><a href="#" className="text-gray-600 hover:text-brand-primary transition-colors flex items-center group">
                  <span className="w-2 h-2 bg-brand-secondary rounded-full mr-3 group-hover:scale-125 transition-transform"></span>
                  Triển khai AI Solutions
                </a></li>
                <li><a href="#" className="text-gray-600 hover:text-brand-primary transition-colors flex items-center group">
                  <span className="w-2 h-2 bg-brand-secondary rounded-full mr-3 group-hover:scale-125 transition-transform"></span>
                  Đào tạo AI chuyên nghiệp
                </a></li>
                <li><a href="#" className="text-gray-600 hover:text-brand-primary transition-colors flex items-center group">
                  <span className="w-2 h-2 bg-brand-secondary rounded-full mr-3 group-hover:scale-125 transition-transform"></span>
                  Chuyển giao công nghệ
                </a></li>
                <li><a href="#" className="text-gray-600 hover:text-brand-primary transition-colors flex items-center group">
                  <span className="w-2 h-2 bg-brand-secondary rounded-full mr-3 group-hover:scale-125 transition-transform"></span>
                  Hỗ trợ kỹ thuật
                </a></li>
              </ul>
            </div>
            
            {/* Contact Info */}
            <div>
              <h4 className="font-bold text-gray-800 text-xl mb-6">Liên hệ</h4>
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <div className="w-8 h-8 bg-gradient-to-r from-brand-primary to-brand-secondary rounded-lg flex items-center justify-center flex-shrink-0">
                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-gray-800 font-semibold">Địa chỉ</p>
                    <p className="text-gray-600 text-sm">Tầng 2, Số 8 Phạm Hùng<br />Phường Yên Hòa, TP Hà Nội</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <div className="w-8 h-8 bg-gradient-to-r from-brand-primary to-brand-secondary rounded-lg flex items-center justify-center flex-shrink-0">
                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-gray-800 font-semibold">Email</p>
                    <p className="text-gray-600 text-sm">info@starai.vn</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <div className="w-8 h-8 bg-gradient-to-r from-brand-primary to-brand-secondary rounded-lg flex items-center justify-center flex-shrink-0">
                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-gray-800 font-semibold">Điện thoại</p>
                    <p className="text-gray-600 text-sm">+84 904 871 813</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <div className="w-8 h-8 bg-gradient-to-r from-brand-primary to-brand-secondary rounded-lg flex items-center justify-center flex-shrink-0">
                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9v-9m0-9v9" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-gray-800 font-semibold">Website</p>
                    <p className="text-gray-600 text-sm">www.StarAI.vn</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="border-t border-gray-200/50 bg-white/50 backdrop-blur-sm">
          <div className="max-w-7xl mx-auto px-4 sm:px-8 py-6">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <div className="flex items-center space-x-6 mb-4 md:mb-0">
                <p className="text-gray-600 text-sm">
                  © 2025 <span className="font-semibold text-brand-primary">StarAI</span>. All rights reserved.
                </p>
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                  <span className="text-green-600 text-sm font-medium">Online 24/7</span>
                </div>
              </div>
              <div className="flex space-x-6">
                <a href="#" className="text-gray-500 hover:text-brand-primary text-sm transition-colors font-medium">Chính sách bảo mật</a>
                <a href="#" className="text-gray-500 hover:text-brand-primary text-sm transition-colors font-medium">Điều khoản sử dụng</a>
                <a href="#" className="text-gray-500 hover:text-brand-primary text-sm transition-colors font-medium">Sitemap</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 